import React from 'react';

class Error extends React.Component {
  render() {
    return <div className="container">
      <br/>
      <h4>404 Not Found</h4>
      ｴｲｻｧｰｰｲ ﾊﾗﾏｽｺｫｰｰｰｰｲ
    </div>;
  }
}

export default Error;